// The currency the tier examples show prices in. The club config can hold
// a code (the server's "NOK") instead of what people write ("kr"), so the
// Nordic codes become "kr"; symbols like "£" are kept.
const KRONA_CODES = ['NOK', 'SEK', 'DKK', 'ISK'];

const exampleCurrency = (config) => {
  const currency = `${config?.currencyShortSmall || ''}`.trim();
  if (!currency || KRONA_CODES.includes(currency.toUpperCase())) {
    return 'kr';
  }
  return currency;
};

export default exampleCurrency;
